import React from 'react';

import { useSelector } from 'react-redux';

import { selectDashboard } from 'containers/Dashboard/selectors';
import { FindingsWithAreaChart } from 'containers/Dashboard/utils/FindingsWithAreaChart';

export const DataSecurityFindingsHistory: React.FC = () => {
  const { dataSecurityOpenFindingsHistory } = useSelector(selectDashboard);

  return (
    <FindingsWithAreaChart
      history={dataSecurityOpenFindingsHistory.data}
      isLoadingChart={dataSecurityOpenFindingsHistory.isLoading}
      label="Critical and High Severity Findings"
    />
  );
};
